export default __webpack_public_path__ + "static/media/11.a2b932a3.jpg";